import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { BookAppointmentResponse, UdateDetailsResponse } from '../types';
import { Pets } from '@/features/customers';

export type BookAppointmentDTO = {
  startDate?: any;
  endDate?: any;
  roomId?: any;
  petDetails?: Pets[];
  bookingId?: any;
  petCount: number;
};

export type RoomsBookingRes = {
  bookingFee?: any;
  bookingDuration?: any;
};

export const getBookingCost = ({
  startDate,
  endDate,
  roomId,
  petDetails,
  bookingId,
  petCount,
}: BookAppointmentDTO): Promise<RoomsBookingRes> => {
  return axios.post(`/rooms/${roomId}/boarding/cost`, {
    startDate,
    endDate,
    petDetails,
    bookingId: bookingId ? bookingId : null,
    petCount,
  });
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getBookingCost>;
};

export const useGetBookingCost = ({ config }: UseUpdateBusinessOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {},
    ...config,
    mutationFn: getBookingCost,
  });
};
